const settingsRoutes = {
    Log :`log`,
    Gdpr: "gdpr"
}

export default settingsRoutes;